import gql from 'graphql-tag';

export const GET_SAVED_STORY = gql`
  query getSaveStory(
    $resourceId: String!
    $auth0User: String
    $communityId: String
    $site: String!
  ) {
    getSaveStory(
      input: {
        resourceId: $resourceId
        auth0User: $auth0User
        communityId: $communityId
        site: $site
      }
    ) {
      resourceType
      resourceId
      userData
    }
  }
`;

export default GET_SAVED_STORY;
